import { Component, input, output } from '@angular/core';

@Component({
  selector: 'lib-card',
  standalone: true,
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
})
export class CardComponent {

  // Textos
  title = input.required<string | null>();
  disclaimer = input<string | null>();
  subtitle = input<string[]>();

  // Nome do arquivo do ícone que fica fixo no canto superior direito
  icon = input<string | null>();

  // Define se vai ter alerta (ícone de triangulo)
  isAlert = input<boolean>(false);

  // Define se vai ter info (icone de "i" dentro de um círculo)
  hasInfo = input<boolean>(false);

  iconClicked = output<void>();
  infoClicked = output<void>();

  get iconPath(): string | null {
    return this.icon() ? `/assets/lib/core/icons/${this.icon()}.svg` : null;
  }

  onInfoClick(): void {
    this.infoClicked.emit();
  }
}
